<template>
    <div class="ntfCampana" ref="raiz">
        <button type="button" class="ntfCampana__boton" @click="alternar" :aria-label="$t('notificaciones.titulo')" v-tooltip="$t('notificaciones.titulo')">
            <i class="ti ti-bell"></i>
            <span v-if="n > 0" class="ntfCampana__contador">{{ n > 99 ? '99+' : n }}</span>
        </button>

        <div v-if="abierta" class="ntfPanel">
            <div class="ntfPanel__head">
                <span class="ntfPanel__titulo">{{ $t('notificaciones.titulo') }}</span>
                <span class="ntfPanel__acciones">
                    <button v-if="n > 0" type="button" class="ntfPanel__icono" @click="marcarTodas"
                            :aria-label="$t('notificaciones.marcarTodas')" v-tooltip="$t('notificaciones.marcarTodas')">
                        <i class="ti ti-checks"></i>
                    </button>
                    <button v-if="items.length > 0" type="button" class="ntfPanel__icono" @click="borrarTodas"
                            :aria-label="$t('notificaciones.borrarTodas')" v-tooltip="$t('notificaciones.borrarTodas')">
                        <i class="ti ti-trash"></i>
                    </button>
                </span>
            </div>

            <div class="ntfPanel__lista" @scroll="alDesplazar">
                <div v-if="cargando && items.length === 0" class="ntfPanel__vacio">
                    <span class="spinner-border spinner-border-sm"></span>
                </div>
                <div v-else-if="items.length === 0" class="ntfPanel__vacio">{{ $t('notificaciones.vacio') }}</div>

                <div v-for="item in items" :key="'ntf_' + item.id" class="ntfItem" :class="{'ntfItem--nueva': !item.leida}"
                     role="button" tabindex="0" @click="abrir(item)" @keydown.enter="abrir(item)">
                    <span class="ntfItem__icono"><i :class="item.tipo === 'asignacion' ? 'ti ti-user-check' : (item.tipo === 'prueba' ? 'ti ti-flask' : 'ti ti-arrow-right-circle')"></i></span>
                    <span class="ntfItem__texto">
                        <span class="ntfItem__titulo">{{ item.titulo }}</span>
                        <span v-if="item.mensaje" class="ntfItem__mensaje">{{ item.mensaje }}</span>
                        <span class="ntfItem__fecha">{{ hace(item.createdAt) }}</span>
                    </span>
                    <!-- el punto de "sin leer" y la X de borrar comparten lugar: al pasar el mouse, la X -->
                    <span class="ntfItem__lado">
                        <span v-if="!item.leida" class="ntfItem__punto"></span>
                        <button type="button" class="ntfItem__borrar" :aria-label="$t('notificaciones.borrar')" v-tooltip="$t('notificaciones.borrar')" @click.stop="borrar(item)" @keydown.enter.stop>
                            <i class="ti ti-x"></i>
                        </button>
                    </span>
                </div>
            </div>

            <div v-if="pushSoportado" class="ntfPanel__pie">
                <template v-if="pushRequiereInstalar">
                    <i class="ti ti-device-mobile me-1"></i>{{ $t('notificaciones.pushInstalar') }}
                </template>
                <template v-else-if="pushActivo">
                    <i class="ti ti-bell-ringing me-1"></i>{{ $t('notificaciones.pushActivo') }}
                    <button type="button" class="ntfPanel__accion ms-auto" @click="desactivarPush">{{ $t('notificaciones.pushDesactivar') }}</button>
                </template>
                <template v-else>
                    <i class="ti ti-bell-off me-1"></i>{{ $t('notificaciones.pushInactivo') }}
                    <button type="button" class="ntfPanel__accion ms-auto" @click="activarPush">{{ $t('notificaciones.pushActivar') }}</button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import toolbox from '@/toolbox';
import * as canal from '@/utils/notificacionesCanal';

export default {
    name: 'NotificacionesCampana',
    data() {
        return {
            n: 0,
            abierta: false,
            items: [],
            cargando: false,
            hayMas: true,
            versionLista: null, // versión con la que se cargó la lista
            pushSoportado: false,
            pushActivo: false,
            pushRequiereInstalar: false,
        };
    },
    mounted() {
        canal.iniciar();
        this.desuscribir = canal.suscribir(this.alCambiar);
        document.addEventListener('mousedown', this.clicAfuera);
    },
    beforeUnmount() {
        if (this.desuscribir) this.desuscribir();
        document.removeEventListener('mousedown', this.clicAfuera);
    },
    methods: {
        alCambiar(e) {
            this.n = e.n;
            this.refrescarPush();
            // con el panel abierto, lo nuevo aparece sin tener que cerrarlo
            if (this.abierta && e.cambio) this.cargar(true);
        },
        refrescarPush() {
            this.pushSoportado = canal.pushSoportado();
            this.pushActivo = canal.pushActivo();
            this.pushRequiereInstalar = canal.pushRequiereInstalar();
        },
        alternar() {
            this.abierta = !this.abierta;
            if (this.abierta) {
                this.refrescarPush();
                this.cargar(true);
            }
        },
        clicAfuera(ev) {
            if (this.abierta && this.$refs.raiz && !this.$refs.raiz.contains(ev.target)) this.abierta = false;
        },
        cargar(desdeCero) {
            const self = this;
            if (self.cargando) return;
            if (!desdeCero && !self.hayMas) return;
            self.cargando = true;

            const antesDe = (!desdeCero && self.items.length) ? self.items[self.items.length - 1].id : 0;
            toolbox.doAjax('GET', 'notificaciones/listado' + (antesDe ? '?antesDe=' + antesDe : ''), {}, function (r) {
                const d = r.data || {};
                const nuevos = d.items || [];
                self.items = desdeCero ? nuevos : self.items.concat(nuevos);
                self.hayMas = nuevos.length === 20;
                self.cargando = false;
                canal.actualizar(d.v, d.n);
            }, function () {
                self.cargando = false;
            }, {}, false);
        },
        alDesplazar(ev) {
            const el = ev.target;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) this.cargar(false);
        },
        marcar(ids) {
            toolbox.doAjax('POST', 'notificaciones/leer', {ids: ids}, function (r) {
                const d = r.data || {};
                canal.actualizar(d.v, d.n);
            }, function () {}, {}, false);
        },
        marcarTodas() {
            this.items.forEach(function (i) { i.leida = 1; });
            this.marcar([]);
        },
        borrar(item) {
            const self = this;
            // se quita de la lista en el momento; si el backend falla, se recarga
            self.items = self.items.filter(function (i) { return i.id !== item.id; });
            toolbox.doAjax('POST', 'notificaciones/borrar', {ids: [item.id]}, function (r) {
                const d = r.data || {};
                canal.actualizar(d.v, d.n);
            }, function () {
                self.cargar(true);
            }, {}, false);
        },
        borrarTodas() {
            const self = this;
            toolbox.confirm(self.$t('notificaciones.confirmBorrarTodas'), function () {
                self.items = [];
                self.hayMas = false;
                toolbox.doAjax('POST', 'notificaciones/borrar', {}, function (r) {
                    const d = r.data || {};
                    canal.actualizar(d.v, d.n);
                }, function () {
                    self.cargar(true);
                }, {}, false);
            });
        },
        abrir(item) {
            if (!item.leida) {
                item.leida = 1;
                this.marcar([item.id]);
            }
            this.abierta = false;
            // la url se guarda como "/#/flow/..." para que también sirva en el correo y en push
            const ruta = String(item.url || '').replace(/^\/?#/, '');
            if (ruta && ruta !== '/') this.$router.push(ruta);
        },
        hace(fecha) {
            const t = new Date(String(fecha).replace(' ', 'T')).getTime();
            if (!t) return '';
            const s = Math.max(0, Math.floor((Date.now() - t) / 1000));
            if (s < 60) return this.$t('notificaciones.ahora');
            if (s < 3600) return this.$t('notificaciones.haceMin', {n: Math.floor(s / 60)});
            if (s < 86400) return this.$t('notificaciones.haceHoras', {n: Math.floor(s / 3600)});
            return new Date(t).toLocaleDateString();
        },
        async activarPush() {
            try {
                const msg = await canal.activarPush();
                toolbox.alert(msg, 'success');
            } catch (e) {
                toolbox.alert(e.message, 'danger');
            }
            this.refrescarPush();
        },
        async desactivarPush() {
            try { await canal.desactivarPush(); } catch (e) { /* si falla, al menos se deja de consultar más espaciado */ }
            this.refrescarPush();
        },
    },
};
</script>

<style scoped>
.ntfCampana {
    position: relative;
}

.ntfCampana__boton {
    position: relative;
    margin-top: 0.2em; /* centra el ícono con el resto del header */
    background: transparent;
    border: 0;
    color: #fff;
    font-size: 1.45em;
    padding: 0.15rem 0.4rem;
    line-height: 1;
    cursor: pointer;
}

.ntfCampana__contador {
    position: absolute;
    top: -2px;
    right: -4px;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: 9px;
    background: var(--cui-danger);
    color: #fff;
    font-size: 0.68rem;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
}

.ntfPanel {
    position: absolute;
    right: 0;
    top: calc(100% + 10px);
    width: 360px;
    max-width: calc(100vw - 24px);
    background: #fff;
    color: var(--cui-body-color, #2c2e32);
    border: 1px solid var(--cui-border-color, #e4e6ea);
    border-radius: 12px;
    box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
    z-index: 1050;
    overflow: hidden;
}

/* En el celular la campana no está pegada al borde (a su derecha van usuario y cerrar sesión):
   anclado a ella, el panel se saldría por la izquierda. Ocupa el ancho de la pantalla. */
@media (max-width: 576px) {
    .ntfPanel {
        position: fixed;
        top: 58px;
        left: 12px;
        right: 12px;
        width: auto;
        max-width: none;
    }
    .ntfPanel__lista {
        max-height: calc(100vh - 200px);
    }
}

.ntfPanel__head,
.ntfPanel__pie {
    display: flex;
    align-items: center;
    padding: 0.7rem 0.9rem;
    font-size: 0.82rem;
}

.ntfPanel__head {
    border-bottom: 1px solid var(--cui-border-color, #e4e6ea);
    justify-content: space-between;
}

.ntfPanel__pie {
    border-top: 1px solid var(--cui-border-color, #e4e6ea);
    background: var(--cui-gray-100);
    color: var(--cui-secondary-color, #6e7278);
}

.ntfPanel__titulo {
    font-weight: 700;
    font-size: 0.92rem;
}

.ntfPanel__acciones {
    display: flex;
    gap: 0.25rem;
}

.ntfPanel__icono {
    width: 30px;
    height: 30px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: var(--cui-gray-600);
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
}

.ntfPanel__icono:hover,
.ntfPanel__icono:focus-visible {
    background: var(--cui-gray-200);
    color: var(--cui-gray-900);
}

.ntfPanel__accion {
    background: transparent;
    border: 0;
    padding: 0;
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--cui-gray-800);
    text-decoration: underline;
    cursor: pointer;
}

.ntfPanel__lista {
    max-height: 420px;
    overflow-y: auto;
}

.ntfPanel__vacio {
    padding: 2rem 1rem;
    text-align: center;
    font-size: 0.85rem;
    color: var(--cui-secondary-color, #6e7278);
}

.ntfItem {
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    gap: 0.7rem;
    padding: 0.75rem 0.9rem;
    color: inherit;
    text-decoration: none;
    border-bottom: 1px solid var(--cui-gray-100);
}

.ntfItem:hover {
    background: var(--cui-gray-100);
}

/* sin leer: fondo en tono, sin color de acento */
.ntfItem--nueva {
    background: rgba(44, 46, 50, 0.04);
}

.ntfItem__icono {
    flex: 0 0 auto;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--cui-gray-200);
    color: var(--cui-gray-700);
}

.ntfItem__texto {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.ntfItem__titulo {
    font-size: 0.85rem;
    font-weight: 600;
    line-height: 1.3;
}

.ntfItem--nueva .ntfItem__titulo {
    font-weight: 700;
}

.ntfItem__mensaje {
    font-size: 0.78rem;
    line-height: 1.35;
    color: var(--cui-secondary-color, #6e7278);
    /* hasta dos líneas de detalle; el resto, con puntos suspensivos */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    overflow-wrap: anywhere;
}

.ntfItem__fecha {
    font-size: 0.72rem;
    color: var(--cui-gray-500);
    margin-top: 2px;
}

.ntfItem__lado {
    /* alineado con la primera línea del título (0.85rem × 1.3 ≈ 18px): 24px centrados en ella */
    position: relative;
    flex: 0 0 auto;
    width: 24px;
    height: 24px;
    margin-top: -3px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ntfItem__punto {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--cui-gray-800);
}

.ntfItem__borrar {
    position: absolute;
    inset: 0;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: var(--cui-gray-500);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity var(--transition-fast, 0.15s), background 0.15s;
}

.ntfItem:hover .ntfItem__borrar,
.ntfItem__borrar:focus-visible {
    opacity: 1;
}

.ntfItem:hover .ntfItem__punto,
.ntfItem__lado:focus-within .ntfItem__punto {
    opacity: 0;
}

.ntfItem__borrar:hover {
    background: var(--cui-gray-200);
    color: var(--cui-gray-800);
}

/* en pantallas táctiles no hay hover: queda la X (el fondo y el título en negrita ya dicen
   que no está leída) */
@media (hover: none) {
    .ntfItem__borrar {
        opacity: 1;
    }
    .ntfItem__punto {
        opacity: 0;
    }
}
</style>
